import { render, staticRenderFns } from "./suspend.vue?vue&type=template&id=23d7e2cb"
import script from "./suspend.vue?vue&type=script&lang=js"
export * from "./suspend.vue?vue&type=script&lang=js"
import style1 from "./suspend.vue?vue&type=style&index=1&id=23d7e2cb&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports